<div class="ds-legal__callout">
  <dl class="ds-legal__dl">
    <dt>Şirket Unvanı</dt>
    <dd>Keyo Dijital Çözümler A.Ş.</dd>

    <dt>Adres</dt>
    <dd>Sultan Selim Mah. Eski Büyükdere Cad. Silahtaroğlu Sok. Yaba Plaza 2 Kat:1, 4.Levent / İstanbul</dd>

    <dt>Telefon</dt>
    <dd><a href="tel:+908503099009">0850 309 9009</a></dd>

    <dt>E-posta</dt>
    <dd>
      <a href="mailto:info&#64;keyodigital.com">info&#64;keyodigital.com</a><br>
      <a href="mailto:operasyon&#64;keyodigital.com">operasyon&#64;keyodigital.com</a>
    </dd>

    <dt>KEP Adresi</dt>
    <dd>keyodijitala.s&#64;hs01.kep.tr</dd>

    <dt>İnternet Sitesi</dt>
    <dd><a href="https://keyo-ai.com">keyo-ai.com</a></dd>
  </dl>
  <!-- TODO: Vergi dairesi / vergi no, MERSİS no, ticaret sicil no ve VERBİS
       kayıt numarası temin edildiğinde bu listeye eklenmelidir. Bilgiler
       doğrulanmadan yayına alınmamalıdır. -->
</div>
